__turbopack_context__.v({
  "backdrop": "popover-module-sass-module__53tPuq__backdrop",
  "bottom": "popover-module-sass-module__53tPuq__bottom",
  "left": "popover-module-sass-module__53tPuq__left",
  "notVisible": "popover-module-sass-module__53tPuq__notVisible",
  "popover": "popover-module-sass-module__53tPuq__popover",
  "popoverContent": "popover-module-sass-module__53tPuq__popoverContent",
  "right": "popover-module-sass-module__53tPuq__right",
  "top": "popover-module-sass-module__53tPuq__top",
  "trigger": "popover-module-sass-module__53tPuq__trigger",
  "visible": "popover-module-sass-module__53tPuq__visible",
});
